var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmoothArrowBottomLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1910_3059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5898 28.1749C14.1554 27.2273 15.7365 26.3088 17.2718 25.3179C18.1495 24.7508 18.8038 23.9331 18.2201 22.8441C17.6612 21.8104 16.6983 22.1266 15.9138 22.5269C11.2265 24.9019 6.50535 27.2099 1.91311 29.7532C-0.0986814 30.8609 -0.00777647 32.3788 2.22365 33.271C7.46422 35.3784 13.0438 35.8729 18.5899 36.4386C19.6241 36.5412 20.5924 36.0749 20.6845 34.8468C20.7736 33.61 19.871 33.228 18.8327 32.9492C18.0161 32.724 17.0412 33.1581 16.1825 32.1284C24.7 30.7528 32.6033 27.9832 39.9891 23.8144C42.276 22.5239 44.4863 21.1028 46.6694 19.6471C47.8824 18.8312 49.7646 17.9675 48.5343 16.1232C47.2432 14.1921 45.8512 15.7883 44.6561 16.6126C36.3418 22.3346 27.3305 26.391 17.3428 28.1415C15.8466 28.4025 14.3301 28.5521 12.8265 28.7515C12.7486 28.5622 12.6676 28.3642 12.5898 28.1749Z",
    fill: "#D7CCFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1910_3059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 35.6406,
    fill: "white",
    transform: "matrix(0.904512 0.426448 0.426448 -0.904512 0 32.2373)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoothArrowBottomLeft);
export default __webpack_public_path__ + "static/media/SmoothArrowBottomLeft.bc4fd0549151dcd96043841306a70d0a.svg";
export { ForwardRef as ReactComponent };